import { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { LOGO_URL } from "@/lib/assets";
import { useOrder } from "@/context/CartContext";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const { openWith, inventory } = useOrder();
  const soldOut = inventory.all_sold_out;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-[#0A0D26]/85 backdrop-blur-xl border-b border-[#F6F0E8]/10"
          : "bg-transparent"
      }`}
    >
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 sm:h-24 flex items-center justify-between">
        {/* Brand on left */}
        <a
          href="#top"
          className="flex items-center gap-3 sm:gap-4"
          data-testid="header-logo"
        >
          <span className="relative inline-block">
            <span className="absolute inset-0 rounded-full bg-[#ED0B09] blur-md opacity-60" />
            <img
              src={LOGO_URL}
              alt="Gullway Nibs"
              className="relative h-12 w-12 sm:h-14 sm:w-14 rounded-full object-cover ring-2 ring-[#F4A623]/60"
            />
          </span>
          <span className="font-display text-2xl sm:text-3xl tracking-wide text-[#F6F0E8]">
            GULLWAY <span className="text-[#ED0B09]">NIBS</span>
          </span>
        </a>

        {/* Order button on the right */}
        <button
          type="button"
          onClick={() => openWith(null)}
          data-testid="header-order-button"
          className={`inline-flex items-center gap-2 font-bold uppercase tracking-wider px-4 sm:px-5 py-2 sm:py-2.5 rounded-full transition-all duration-300 ${
            soldOut
              ? "bg-[#171D4F] text-[#F6F0E8] border border-[#F6F0E8]/15"
              : "bg-[#ED0B09] hover:bg-[#B42A27] text-[#F6F0E8] shadow-[0_0_20px_rgba(237,11,9,0.45)] hover:shadow-[0_0_30px_rgba(237,11,9,0.7)] hover:-translate-y-0.5"
          }`}
        >
          <Flame size={16} />
          <span className="hidden xs:inline">{soldOut ? "Sold Out" : "Pre-order"}</span>
          <span className="xs:hidden">{soldOut ? "Sold Out" : "Order"}</span>
        </button>
      </div>
    </header>
  );
}
